import { KeyValues } from '~/src/interface'

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class UrlUtil {
  static getUrlParams (url: string): KeyValues | null {
    let u = url
    if (u.includes('#')) {
      u = url.split('#')[0]
    }
    if (u.includes('?')) {
      const params: KeyValues = {}
      const parmaUrl = u.split('?')[1]
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      if (parmaUrl && parmaUrl.split('&').length) {
        const arr = parmaUrl.split('&')
        let kv
        const len = arr.length
        for (let i = 0; i < len; i++) {
          kv = arr[i].split('=')
          if (kv.length > 1) {
            params[kv[0]] = decodeURIComponent(kv[1])
          }
        }
      }
      return params
    } else {
      return null
    }
  }

  static createUrlParams (keyValues: KeyValues): string {
    return Object.keys(keyValues).map(k => {
      return `${k}=${keyValues[k]}`
    }).join('&')
  }

  static createUrl (url: string, keyValues: KeyValues): string {
    let u = url
    let hashStr = ''
    if (u.includes('#')) {
      u = url.split('#')[0]
      hashStr = '#' + url.split('#')[1]
    }
    if (u.includes('?')) {
      return `${url.split('?')[0]}?${UrlUtil.createUrlParams(keyValues)}${hashStr}`
    } else {
      return `${url}?${UrlUtil.createUrlParams(keyValues)}${hashStr}`
    }
  }

  static createPath (url: string, path: string, keyValues: KeyValues): string {
    let u = url
    let hashStr = ''
    if (u.includes('#')) {
      u = url.split('#')[0]
      hashStr = '#' + url.split('#')[1]
    }
    return `${path}?${UrlUtil.createUrlParams(keyValues)}${hashStr}`
  }
}
